var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-slider',{attrs:{"value":_vm.calculatedVolume,"min":0,"max":100},on:{"change":function (val){ return _vm.$props.model.volume = val; }}})}
var staticRenderFns = []

export { render, staticRenderFns }